import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { Box, Typography } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Icon,
  Tooltip,
} from "@/components/ui-v2";
import { useBasicData } from "@/hooks";

import { EXPORT_FORM_FIELDS, PNG_SEQUENCE_FORMAT } from "../../../constants";

export const ExportFormMetadata = () => {
  const { workspace } = useBasicData();
  const format = useWatch({ name: EXPORT_FORM_FIELDS.FORMAT });

  const isPngSequence = format === PNG_SEQUENCE_FORMAT;
  const isDisabled = !!workspace?.alwaysIncludeMetadata || isPngSequence;

  if (!workspace) {
    return null;
  }

  return (
    <Box>
      <Typography variant="small" fontWeight={600} sx={{ mb: 1 }}>
        Metadata
      </Typography>
      <FormGroup>
        <Controller
          name={EXPORT_FORM_FIELDS.INCLUDE_METADATA}
          render={({ field }) => {
            const isChecked = isPngSequence ? false : field.value;

            return (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={isChecked}
                    disabled={isDisabled}
                    size="small"
                    sx={{
                      "&.Mui-disabled": {
                        color: "secondary.3",
                      },
                    }}
                  />
                }
                disabled={isDisabled}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <span>Include Layer metadata</span>
                    <Tooltip title="When enabled, exported assets include technical and attribution metadata to support traceability and provenance. This may include a unique inference ID and session ID, generation details (model, style, seed, and refinements), timestamps for generation and export, and standard attribution fields such as creator and copyright.">
                      <Icon icon={faQuestionCircle} />
                    </Tooltip>
                  </Box>
                }
                sx={{
                  "&.Mui-disabled": {
                    opacity: "unset",
                  },
                  "& .MuiFormControlLabel-label.Mui-disabled": {
                    color: "secondary.3",
                  },
                }}
              />
            );
          }}
        />
        {workspace?.alwaysIncludeMetadata && !isPngSequence && (
          <Typography variant="small" color="secondary.3">
            Your workspace requires metadata to be included.
          </Typography>
        )}
        {isPngSequence && (
          <Typography variant="small" color="secondary.3">
            Metadata is not supported for PNG Sequence exports.
          </Typography>
        )}
      </FormGroup>
    </Box>
  );
};
